import React from "react";
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  FormInput,
  FormTextarea,
  Button
} from "shards-react";
import { toast } from 'react-toastify';
import FeatherIcon from 'feather-icons-react';


import PageTitle from "../../../components/common/PageTitle";
import "./InstallationRequest.scss";

let submitDataInit = {
  boardName: "installationRequest",
  status: "published",
  visibility: "private",
  isSecret: true,
  locked: false,
  contact: "",
  email: "",
  info_1: "",
  info_2: "",
  info_3: "secondary",
  content: "",
  attachments: [],
}

@inject(({ teamUser }) => ({isLogin: teamUser.isLogin, me: teamUser.me}))
@inject(({ board }) => ({updateBoard: board.updateBoard}))
@inject(({ common }) => ({uploadImages: common.uploadImages}))

@observer
class InstallationRequest extends React.Component {
  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  //page
  @observable submitData = submitDataInit;
  @observable isUploading = false;

  componentDidMount() {
    this.init();
  }

  @action
  init = async () => {
    if(this.props.isLogin) {
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};

      // 결제(무료결제) 전 사용자는 결제 페이지로 이동
      // if(!this.teamUser.isPaidShop) {
      //   alert('해당 페이지는 결제(무료결제) 후 이용 가능합니다.');
      //   window.location.href = '/inAppOrder';
      //   return;
      // }

      this.submitData.store_id = this.store._id;
      this.submitData.teamUser_id = this.teamUser._id;
      this.submitData.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo : 1;
      this.submitData.authorName = this.teamUser.name ? this.teamUser.name : "";
    }
  };

  initNewReview = async () => {
    // 새 객체/배열로 초기화 (submitDataInit 원본 참조 오염 방지)
    this.submitData = { ...submitDataInit, attachments: [] };
    this.submitData.store_id = this.store._id;
    this.submitData.teamUser_id = this.teamUser._id;
    this.submitData.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo : 1;
    this.submitData.authorName = this.teamUser.name ? this.teamUser.name : "";
  };

  formatPhoneNumber = (value) => {
    // 숫자만 추출
    const numbers = value.replace(/[^\d]/g, '');

    // 길이에 따라 포맷팅
    if (numbers.length <= 3) {
      return numbers;
    } else if (numbers.length <= 7) {
      return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    } else if (numbers.length <= 11) {
      return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
    } else {
      return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
    }
  };

  onChangeValue = async (event) => {
    const { name, value } = event.target;

    // 핸드폰 번호인 경우 자동 포맷팅
    if (name === 'contact') {
      this.submitData[name] = this.formatPhoneNumber(value);
    } else if(name === 'password') {
      this.submitData[name] = value;
    } else {
      this.submitData[name] = value;
    }
  };

  formatFileSize = (size) => {
    if (!size && size !== 0) return '';
    if (size < 1024) return size + ' B';
    if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
    return (size / (1024 * 1024)).toFixed(1) + ' MB';
  };

  // 파일 첨부 — Inquiry 와 동일 패턴 (단, 이미지 외 일반 파일도 허용)
  onFileChange = async (event) => {
    const inputEl = event.target;
    const files = inputEl.files;
    if (!files || files.length === 0) return;

    const maxFiles = 5;
    const currentCount = (this.submitData.attachments || []).length;
    if (currentCount + files.length > maxFiles) {
      toast(`파일은 최대 ${maxFiles}개까지 첨부 가능합니다.`);
      if (inputEl) inputEl.value = "";
      return;
    }

    this.isUploading = true;
    let uploadedCount = 0;
    try {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (file.size / 1000000 > 10) {
          toast(`${file.name} 은(는) 10MB를 초과하여 첨부할 수 없습니다.`);
          continue;
        }

        const formData = new FormData();
        formData.append("file", file);

        const res = await this.props.uploadImages(formData);
        if (res && Array.isArray(res) && res[0] && res[0].fullPath) {
          if (!this.submitData.attachments) this.submitData.attachments = [];
          const isImage = file.type && file.type.startsWith('image/');
          this.submitData.attachments.push({
            type: isImage ? 'image' : 'file',
            url: res[0].fullPath,
            size: file.size,
            meta: { filename: file.name, mime: file.type }
          });
          uploadedCount++;
        } else {
          toast(`${file.name} 업로드에 실패했습니다.`);
        }
      }
      if (uploadedCount > 0) {
        toast.success('파일이 첨부되었습니다.');
      }
    } catch (err) {
      console.error(err);
      toast('파일 업로드 중 오류가 발생했습니다.');
    } finally {
      this.isUploading = false;
      if (inputEl) inputEl.value = "";
    }
  };

  removeAttachment = (index) => {
    if (!this.submitData.attachments) return;
    this.submitData.attachments.splice(index, 1);
  };

  onSubmit = async (data) => {
    let _this = this;

    // 기본 필수 필드
    let validFields = [
      {fildName: "authorName", alert: "담당자 이름을 입력해 주세요."},
      {fildName: "contact", alert: "핸드폰 번호를 입력해 주세요.'"},
      {fildName: "email", alert: "이메일 주소를 입력해 주세요."},
    ];


    let isValid = true;
    for(let i=0; i<validFields.length; i++) {
      if(!data[validFields[i].fildName] || data[validFields[i].fildName] === '') {
        toast(validFields[i].alert);
        isValid = false;
        break;
      }
    }

    data.notifyAuthor = true;
    if(isValid) {
      this.props.updateBoard(data, function(res) {
        if(res.errors && res.errors.length > 0) {
          toast(res.errors[0].message);
        }
        else {
          toast("설치 요청이 완료되었습니다.");
          // 성공 시 내 설치 요청 페이지로 이동
          window.location.href = "/myBoard";
        }
        _this.initNewReview();

      });
    }




  };

  render() {

    return (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            title="설치 요청"
            subtitle="설치에 필요한 정보를 입력해주세요."
            className="text-sm-left mb-3"
          />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <CardHeader className="border-bottom">
                <h6 className="m-0">설치 정보 입력</h6>
              </CardHeader>
              <CardBody className="p-0 pb-3">
                <div className="p-4 mb-3 bg-info-light border-left-info" style={{backgroundColor: '#e7f3ff', borderLeft: '4px solid #007bff'}}>
                  <p className="mb-2" style={{fontSize: '1.1rem'}}>
                    <strong><span role="img" aria-label="로켓">🚀</span> 지금 바로 빠르게 설치하세요!</strong>
                  </p>
                  <p className="mb-2" style={{fontSize: '0.95rem'}}>
                    <a href="/easySetting" style={{textDecoration: 'underline', fontWeight: 'bold', color: '#007bff'}}>빠른 설치 페이지</a>에서는
                    <strong> 5분 이내</strong>에 직접 설치를 완료하실 수 있습니다.
                  </p>
                  <p className="mb-0 text-muted" style={{fontSize: '0.9rem'}}>
                    <span role="img" aria-label="체크">✓</span> 설치 요청서 작성 없이 즉시 설치 가능<br/>
                    <span role="img" aria-label="체크">✓</span> 대기 시간 없이 바로 이용 시작
                  </p>
                </div>
                <div className="p-4 mb-3" style={{backgroundColor: '#d1ecf1', borderLeft: '4px solid #17a2b8'}}>
                  <p className="mb-2" style={{fontSize: '1.1rem'}}>
                    <strong><span role="img" aria-label="정보">ℹ️</span> 설치 시간 안내</strong>
                  </p>
                  <p className="mb-2" style={{fontSize: '0.95rem'}}>
                    <span role="img" aria-label="체크">✓</span> <strong>오후 2시 이전 신청</strong> 시 당일 설치 완료됩니다.<br/>
                    <span className="text-muted" style={{fontSize: '0.9rem', marginLeft: '1.2rem'}}>
                      (단, 디자인 코드 작업에 어려움이 있는 경우 해당 내용에 대한 답변을 회신으로 전달드립니다)
                    </span>
                  </p>
                  <p className="mb-2" style={{fontSize: '0.95rem'}}>
                    <span role="img" aria-label="체크">✓</span> 설치 신청 후 <strong>'설치 중'</strong>으로 상태 변경된 후 평균적으로 <strong>1시간 ~ 3시간 사이</strong>에 설치가 완료됩니다.
                  </p>
                  <p className="mb-0" style={{fontSize: '0.95rem'}}>
                    <span role="img" aria-label="체크">✓</span> <strong>공휴일</strong>에 신청한 경우 영업일의 가장 빠른 설치 순서로 진행됩니다.
                  </p>
                </div>
                <Form className="p-3" onSubmit={this.onSubmit}>
                  <Row form>
                    <Col md="6" className="form-group">
                      <label htmlFor="name">쇼핑몰</label>
                      <FormInput
                          id="name"
                          name="name"
                          type="text"
                          disabled={true}
                          placeholder="쇼핑몰명을 입력해주세요."
                          value={this.store && this.store.name ? this.store.name : ""}
                      />
                    </Col>
                    <Col md="6" className="form-group">
                      <label htmlFor="authorName">담당자</label>
                      <FormInput
                          id="authorName"
                          name="authorName"
                          type="text"
                          placeholder="담당자 이름을 입력해주세요."
                          value={this.submitData.authorName ? this.submitData.authorName : ""}
                          onChange={event => {
                            this.onChangeValue(event)
                          }}
                      />
                    </Col>
                  </Row>
                  <Row form>
                    <Col md="6" className="form-group">
                      <label htmlFor="contact">핸드폰</label>
                      <FormInput
                        id="contact"
                        name="contact"
                        type="text"
                        placeholder="010-0000-0000"
                        required={true}
                        value={this.submitData.contact}
                        onChange={event => {
                          this.onChangeValue(event)
                        }}
                      />
                    </Col>
                    <Col md="6" className="form-group">
                      <label htmlFor="email">이메일</label>
                      <FormInput
                          id="email"
                          name="email"
                          type="email"
                          required={true}
                          placeholder="이메일 주소를 입력해주세요."
                          value={this.submitData.email}
                          onChange={event => {
                            this.onChangeValue(event)
                          }}
                      />
                    </Col>
                  </Row>

                  <FormGroup>
                    <label htmlFor="content">설치 요청 세부 내용</label>
                    <FormTextarea
                      id="content"
                      name="content"
                      placeholder="설치 시 필요한 세부 요청사항이나 특이사항을 입력해주세요."
                      rows="5"
                      value={this.submitData.content}
                      onChange={event => {
                        this.onChangeValue(event)
                      }}
                    />
                  </FormGroup>

                  <FormGroup>
                    <label htmlFor="attachments">파일 첨부 <span className="text-muted" style={{fontSize: '0.85rem'}}>(선택, 최대 5개 · 파일당 10MB 이하)</span></label>
                    <div>
                      <input
                        id="attachments"
                        type="file"
                        multiple
                        onChange={this.onFileChange}
                        disabled={this.isUploading}
                        style={{display: 'block', marginBottom: 8}}
                      />
                      <p className="text-muted mb-2" style={{fontSize: '0.85rem'}}>
                        디자인 참고 이미지, 적용 화면 캡처 등 설치에 도움이 되는 파일을 첨부해주세요.
                      </p>
                      {this.isUploading && <p className="text-muted mb-2" style={{fontSize: '0.9rem'}}>업로드 중...</p>}
                      {this.submitData.attachments && this.submitData.attachments.length > 0 && (
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8}}>
                          {this.submitData.attachments.map((file, idx) => {
                            const filename = (file.meta && file.meta.filename) || (file.url ? file.url.split('/').pop() : `첨부 ${idx + 1}`);
                            if (file.type === 'image') {
                              return (
                                <div key={idx} style={{position: 'relative', width: 100, height: 100, border: '1px solid #e1e5eb', borderRadius: 4, overflow: 'hidden'}}>
                                  <img src={file.url} alt={filename} style={{width: '100%', height: '100%', objectFit: 'cover'}}/>
                                  <button
                                    type="button"
                                    onClick={() => this.removeAttachment(idx)}
                                    style={{
                                      position: 'absolute', top: 2, right: 2,
                                      width: 22, height: 22, lineHeight: '20px',
                                      padding: 0, border: 'none', borderRadius: '50%',
                                      background: 'rgba(0,0,0,0.6)', color: '#fff',
                                      cursor: 'pointer', fontSize: 14
                                    }}
                                    aria-label="첨부 삭제"
                                  >×</button>
                                </div>
                              );
                            }
                            return (
                              <div key={idx} style={{display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 10px', border: '1px solid #e1e5eb', borderRadius: 4, background: '#f8f9fa', fontSize: '0.85rem', maxWidth: 280}}>
                                <FeatherIcon icon="paperclip" size="13" style={{flexShrink: 0}} />
                                <span style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}} title={filename}>{filename}</span>
                                {file.size ? <span className="text-muted" style={{flexShrink: 0}}>({this.formatFileSize(file.size)})</span> : null}
                                <button
                                  type="button"
                                  onClick={() => this.removeAttachment(idx)}
                                  style={{
                                    flexShrink: 0, width: 18, height: 18, lineHeight: '16px',
                                    padding: 0, border: 'none', borderRadius: '50%',
                                    background: 'rgba(0,0,0,0.45)', color: '#fff',
                                    cursor: 'pointer', fontSize: 12
                                  }}
                                  aria-label="첨부 삭제"
                                >×</button>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </FormGroup>

                  <Row>
                    <Col className="text-center" ><Button onClick={event => this.onSubmit(this.submitData)} disabled={this.isUploading}>신청하기</Button></Col>
                  </Row>

                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default InstallationRequest;
